<template>
<div class="rentsrecharge">
  <div class="top bottomline">
    <div class="item rigthline">
      累计积分：<span class="num">{{honor.point}}</span>
    </div>
    <div class="item">
      租赁金额：<span class="num">{{sel.deposit}}</span>
    </div>
  </div>
  <div class="app-main-scroll">
  <div class="list">
    <div v-for="(v,k) in honorInfo" v-bind:key="k" class="item app-seal" :class="['app-seal'+v.id,[sel.id==v.id?'on':'']]" @click="dealsel(v)">
      <div class="left">
        <p>{{v.title}}</p>
        <span class="need">>{{v.point}}积分</span>
      </div>
      <div class="right"></div>
      <span class="discount">{{v.discount/10}}折</span>
    </div>
  </div>

  <div class="app-btn-area weui-btn-area">
    <div @click="rentsrecharge" class="weui-btn">确认租赁</div>
  </div>
  </div>
</div>
</template>

<script>
export default {
data(){
  return{
    honor:{},
    honorInfo:[],
    sel:{deposit:0}
  }
},
  mounted() {
      this.getHonorInfo();
  },
methods:{
    getHonorInfo(){
      let vm = this;
      vm.ajax("account/honor", "get", '', e => {
        vm.honor = e.data;
        vm.honorInfo = e.data.list;
      })
    },
    dealsel(v) {
      let vm = this;
      if(vm.honor.point < v.point){
        vm.publics.message.danger('您的积分不够！');
      }else{
        vm.sel = v;
      }
    },
    rentsrecharge(){
      let vm =this;
      if( !(vm.sel.id>0) ){
        vm.publics.message.danger('请选择您要租赁的印章！');
        return false;
      }
      vm.order({"honor":vm.sel.id})
      // vm.ajax("account/honor/buy", "post", {honor:vm.sel.id}, e => {
      //   vm.publics.message.success('印章租赁成功！');
      //   vm.$router.go(-1)
      // })
    },
    order(data) {
        let vm = this;
        var data = JSON.stringify(data);
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.addEventListener("readystatechange", function() {
            if (this.readyState === this.DONE) {
                console.log(this.responseText);
                /* var req = JSON.parse(this.responseText); */
                let response = JSON.parse(this.response);
                if (response.code != 1000) {
                    alert(response.error)
                } else {
                    // ----- pay weixin ---
                    var req = response.data;
                    console.log(req);
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                        }
                    } else {
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', req,
                            function(res) {
                                if (res.err_msg == "get_brand_wcpay_request:ok") {
                                    // 使用以上方式判断前端返回,微信团队郑重提示：
                                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                                        // alert("ok")
                                        vm.publics.message.success('印章租赁成功！');
                                        vm.$router.go(-1)
                                    } else {
                                        // alert("error")
                                            //支付失败/或取消支付跳转页面
                                    }
                                }
                            });
                    }
                    // -- pay end --
                }
            }
        });
        xhr.open("POST", vm.publics.API_URL+"account/honor/buy");
        xhr.setRequestHeader("content-type", "application/json");
        xhr.send(data);
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/rentsrecharge.vue